import { EventsService } from 'src/app/services/event/event.service';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { LoyaltyProgramProvider } from 'src/app/services/loyalty-program/loyalty-program.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { digitsOnlyValidator } from "src/app/services/customFormValidators";
import { SiteContentService } from "src/app/services/sitecontent/sitecontent.service";
import { SiteContentInterface } from "src/app/interfaces/sitecontent-interface";
import { mustBeTruthy } from 'src/app/services/customFormValidators';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { SidemenuService } from 'src/app/services/lobby/sidemenu.service';


@Component({
  selector: 'page-loyalty-program',
  templateUrl: './loyalty-program.html',
  styleUrls: ['./loyalty-program.scss'],
})

export class LoyaltyProgramPage implements OnInit {
  public error;
  public isConnected: boolean;
  private cardUpdateListener: EventListener;


  public loyaltyProgramForm: FormGroup;
  public loyalty_card_id: AbstractControl;
  public loyalty_consent: AbstractControl;
  public labels: any = [];

  constructor(
    public appLinks: AppLinksService,
    private loyaltyProgramProvider: LoyaltyProgramProvider,
    private events: EventsService,
    private siteContentService: SiteContentService,
    private successMessageProvider: SuccessMessageService,
    private sidemenuService:SidemenuService
  ) {

    this.checkLoyaltyProgram();
    this.loyaltyProgramProvider.cardConnectEvent.addListener("Card Status Update", (arg) => this.isConnected = arg);
  }

  private checkLoyaltyProgram() : void {
    this.loyaltyProgramProvider.getLoyaltyCard().subscribe((res) => {
      (res.result == 1 && res.payload == true) ? this.isConnected = true : this.isConnected = false;
    })
  }


  ngAfterViewInit() {
    this.siteContentService.loadConfig('loyalty-rewards') //
      .then((response: SiteContentInterface) => {
        this.labels = response;
      })
  }

  ngOnInit(): void {

    this.loyaltyProgramForm = new FormGroup(
      {
        loyalty_card_id: new FormControl('', [digitsOnlyValidator, Validators.maxLength(25), Validators.required]),
        loyalty_consent: new FormControl(false, [mustBeTruthy]),

      }
    );

    this.loyalty_card_id = this.loyaltyProgramForm.get('loyalty_card_id');
    this.loyalty_consent = this.loyaltyProgramForm.get('loyalty_consent');

  }

  openMatchedExternalLinks(code, title){
    return this.appLinks.openMatchedExternalLinksPopover(code, title);
  }

  public onAdd() {
    this.loyaltyProgramProvider.connectLoyaltyCard(this.loyaltyProgramForm.value).subscribe((response) => {
      if (response.result == 1) {
        this.isConnected = true;
        this.sidemenuService.reIterateMenu();
        this.successMessageProvider.setMessage("Your Momentum Account is now connected");
      }
    }, (error) => {
      this.error = error;
    });
  }

}

